// src/schemas/shipmentSchema.js
import { z } from 'zod';

// Define the common fields
const baseSchema = z.object({
    pickupPincode: z.coerce.number({
            required_error: "Pickup pincode is required",
        })
        .int({ message: "Pickup pincode must be an integer" })
        .refine(val => val >= 100000 && val <= 999999, {
            message: "Pickup pincode must be exactly 6 digits",
        }),

    deliveryPincode: z.coerce.number({
            required_error: "Delivery pincode is required",
        })
        .int({ message: "Delivery pincode must be an integer" })
        .refine(val => val >= 100000 && val <= 999999, {
            message: "Delivery pincode must be exactly 6 digits",
        }),

    weight: z.coerce.number({
            required_error: "Weight is required",
        })
        .positive({ message: "Weight must be greater than 0" }),

    length: z.coerce.number({
            required_error: "Length is required",
        })
        .positive({ message: "Length must be greater than 0" }),

    breadth: z.coerce.number({
            required_error: "Breadth is required",
        })
        .positive({ message: "Breadth must be greater than 0" }),

    height: z.coerce.number({
            required_error: "Height is required",
        })
        .positive({ message: "Height must be greater than 0" }),

    serviceMode: z.enum(["Surface", "Air"], {
        required_error: "Service mode is required",
    }),
});

// Prepaid schema: shipmentValue is optional
const prepaidSchema = baseSchema.extend({
    paymentMode: z.literal("Prepaid"),
    shipmentValue: z.preprocess((val) => {
        if (val === "" || val === undefined || val === null) return undefined;
        return Number(val);
    }, z.number().min(0, { message: "Shipment value must be a non-negative number" }).optional()),
});

// COD schema: shipmentValue is required
const codSchema = baseSchema.extend({
    paymentMode: z.literal("COD"),
    shipmentValue: z.preprocess((val) => {
        if (val === "" || val === undefined || val === null) return undefined;
        return Number(val);
    }, z.number({ required_error: "Shipment value is required for COD" }).min(0, { message: "Shipment value must be a non-negative number" })),
});

// Create a discriminated union based on paymentMode
const RateCalcSchema = z.discriminatedUnion("paymentMode", [
    prepaidSchema,
    codSchema,
]);

export default RateCalcSchema;